<template>
	<div class="flow-form-field-wrapper" :inline="inline">
		<div v-if="$slots['label'] || $slots['info']" class="flow-form-field-label-wrapper">
			<!-- @slot Used to display label of form element -->
			<slot name="label" />
			<!-- @slot Used to display meta info of form element -->
			<slot name="info" />
		</div>
		<slot />
		<div v-if="$slots['help']" class="flow-form-field-help">
			<!-- @slot Used to display help text/ error / any message-->
			<slot name="help" />
		</div>
	</div>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
	name: "FormField",
	props: {
		/**
		 * true | false
		 */
		inline: {
			type: Boolean,
			default: false
		}
	}
});
</script>
<style lang="scss">
div.flow-form-field-wrapper {
	display: flex;
	flex-direction: column;
	position: relative;
	gap: 8px;

	&[inline] {
		display: inline-flex;
	}

	> .flow-form-field-label-wrapper {
		display: flex;
		justify-content: space-between;
	}

	// > div.flow-form-field-help {
	// 	min-height: 18px;
	// }
}
</style>
